<template>
  <header class="insights-ia-header">
    <div class="insights-ia-header__title-area">
      <div class="insights-ia-header__title-row">
        <h1>Análise inteligente do DRE</h1>
        <InsightsIABadge label="Beta" />

        <InsightsIABadge
          :variant="InsightsIABadgeVariant.Critical"
          label="Desativado"
          v-if="!ativado"
        />
      </div>
    </div>

    <div class="insights-ia-header__actions">
      <F360Button
        v-if="canUseDevMode"
        outline
        prefix-icon="developer_mode"
        size="small"
        @click="handleDevMode"
      >
        Modo desenvolvedor
      </F360Button>

      <F360Button
        outline
        prefix-icon="settings"
        size="small"
        @click="handleConfigure"
        v-if="ativado"
      >
        Configurações
      </F360Button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { InsightsIABadgeVariant } from "@/ui/components/Bagdes/InsightsBagde/InsightsBagdeTypes";
import InsightsIABadge from "@/ui/components/Bagdes/InsightsBagde/InsightsIABadge.vue";
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";
import useAnalyticsInsightsIA, {
  AnalyticsInsightsIA
} from "@/features/financas/views/InsightsIA/analytics/useInsightsIaAnalytics";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useAgenteDeDreInsigthsStore } from "../../../store/useAgenteDeDreInsigthsStore";

const emit = defineEmits<{
  configure: [];
  devMode: [];
}>();

const agenteDeDreInsigthsStore = useAgenteDeDreInsigthsStore();
const { ativado } = storeToRefs(agenteDeDreInsigthsStore);

const canUseDevMode = computed(() => {
  const url = window.location.href;

  return (
    import.meta.env.DEV ||
    url.includes("hml.f360") ||
    url.includes("homolog") ||
    url.includes("localhost")
  );
});

const analyticsInsightsIA = useAnalyticsInsightsIA();

const handleConfigure = () => {
  analyticsInsightsIA.sendClickEvent(AnalyticsInsightsIA.configuracoes);
  emit("configure");
};

const handleDevMode = () => {
  emit("devMode");
};
</script>

<style scoped lang="scss">
.insights-ia-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  &__title-area {
    display: flex;
    flex-direction: column;
  }

  &__title-row {
    display: flex;
    align-items: center;
    gap: 8px;

    h1 {
      margin: 0;
      color: _map.get($map: $neutro, $key: 950);
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
</style>
